export function setupMediaAutoplayBlocker(document: Document): () => void {
  const selector = 'audio[autoplay], video[autoplay]';

  const disable = (root: ParentNode): void => {
    root.querySelectorAll(selector).forEach(node => {
      const media = node as HTMLMediaElement;

      media.removeAttribute('autoplay');
      media.autoplay = false;
      media.pause();
    });
  };

  const disableMedia = (media: HTMLMediaElement): void => {
    media.removeAttribute('autoplay');
    media.autoplay = false;
    media.pause();
  };

  // Covers media that exists before Angular finishes bootstrapping.
  disable(document);

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const target = mutation.target;

        if (target instanceof HTMLMediaElement && target.matches(selector)) {
          disableMedia(target);
        }

        continue;
      }

      mutation.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;

        // Covers a directly inserted <audio autoplay> or <video autoplay>.
        if (node instanceof HTMLMediaElement && node.matches(selector)) {
          disableMedia(node);
        }

        // Covers media nested in newly inserted message/HTML-preview wrappers.
        disable(node);
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['autoplay']
  });

  return () => observer.disconnect();
}
